//
// ┌─────────────────────┐
// │ DO NOT EDIT BY HAND │
// └─────────────────────┘
//
// Generated by build.mjs in zinnia-icons
//
import { mapPropsToSvgProps, Props } from "../utils";
function IconRatingHeart(iconProps: Props) {
  const props = mapPropsToSvgProps(iconProps);
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M12 21.31C13.02 20.45 16.11 17.96 21.01 12.58C22.06 11.43 22.58 9.94 22.49 8.39C22.4 6.85 21.71 5.43 20.54 4.42C18.51 2.65 15.54 2.58 13.42 4.09C13.94 4.7 14.33 5.15 14.73 5.63C16.1 4.74 17.95 4.81 19.23 5.93C19.99 6.59 20.44 7.51 20.5 8.51C20.56 9.52 20.21 10.49 19.53 11.24C16.84 14.19 14.31 16.7 12 18.7C10.01 16.99 7.25999 14.56 4.46999 11.27C3.06999 9.61 3.19999 7.27 4.73999 5.92C6.25999 4.59 8.60999 4.73 9.97999 6.23C10.37 6.66 12.59 9.29 13.02 9.8L14.53 8.55C13.63 7.43 11.56 4.99 11.46 4.89C9.36999 2.59 5.76999 2.38 3.42999 4.42C1.04999 6.5 0.829988 10.07 2.93999 12.56C6.36999 16.59 9.69999 19.35 12 21.31Z" fill="currentColor" /></svg>;
}
export default IconRatingHeart;